import * as types from "src/store/types/fidelidade_dashboard";

const INITIAL_STATE = {
  loading: false,
  grafico_transacoes: {
    valor_recebidos: [],
    valor_enviados: [],
    qtde_recebidos: [],
    qtde_enviados: [],
    data: [],
  },
  totalizadores: {
    total_clientes: 0,
    total_clientes_cashback: 0,
    ticket_medio: 0,
    total_cashback: 0,
    total_presentes: 0,
    total_clientes_presentes: 0,
    total_cashback_vencendo: 0,
    qtde_cashback_vencendo: 0,
  },
  comparativos: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.FIDELIDADE_DASHBOARD_LOADING:
      return { ...state, loading: action.payload };
    case types.FIDELIDADE_DASHBOARD_TOTALIZADORES:
      return { ...state, totalizadores: action.payload };
    case types.FIDELIDADE_DASHBOARD_GRAFICO_TRANSACOES:
      return { ...state, grafico_transacoes: action.payload };
    case types.FIDELIDADE_DASHBOARD_COMPARATIVOS:
      return { ...state, comparativos: action.payload };
    default:
      return state;
  }
};
